module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-17.690dceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-17.jpg
// module id = zwCj
// module chunks = 52